export default __webpack_public_path__ + "static/media/registrar-sign-up-header.78241f1e.png";